// extracted by mini-css-extract-plugin
export var logo = "_kj-2";
export var logoWrapper = "_kj-1";
export var strip = "_kj-0";